var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9388 4.2681V5.91448M7.06055 4.2681V5.91448",
    stroke: "#3A86DD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3535 16.6159L10.3535 13.609C10.3535 13.4512 10.2409 13.3232 10.102 13.3232H9.53027M13.3414 16.6159L14.4564 13.6106C14.5085 13.4701 14.3976 13.3232 14.2395 13.3232H12.823",
    stroke: "#3A86DD",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17969 12.7002C4.17969 9.11334 4.17969 7.31989 5.21042 6.20558C6.24115 5.09128 7.90009 5.09128 11.218 5.09128H12.782C16.0999 5.09128 17.7589 5.09128 18.7896 6.20558C19.8203 7.31989 19.8203 9.11334 19.8203 12.7002V13.123C19.8203 16.7099 19.8203 18.5033 18.7896 19.6176C17.7589 20.7319 16.0999 20.7319 12.782 20.7319H11.218C7.90009 20.7319 6.24115 20.7319 5.21042 19.6176C4.17969 18.5033 4.17969 16.7099 4.17969 13.123V12.7002Z",
    stroke: "#3A86DD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06055 9.20724H16.9388",
    stroke: "#3A86DD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.1a132a0e8924897756f7992d0e584564.svg";
export { ForwardRef as ReactComponent };